import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Icon, Input } from '@.ui';
import { LinkHelper } from '@/Services';

import { storeClusterDetailStoreSelectors } from '../../../model/ClusterStoreDetailStore';
import S from './ClusterStoreDetailHeader.module.scss';

export const ClusterStoreDetailHeader = () => {
    const navigate = useNavigate();

    const cluster = storeClusterDetailStoreSelectors.use.cluster();
    const searchStoreName = storeClusterDetailStoreSelectors.use.searchStoreName();

    const changeSearchStoreName = storeClusterDetailStoreSelectors.use.changeSearchStoreName();

    const toClusterDashboard = () => {
        if (cluster) {
            navigate(LinkHelper.serviceProvider.storeClusterAdminDashboard(cluster.clusterId));
        }
    };

    const clusterName = cluster?.clusterName || '';

    return (
        <div>
            <h1>Cluster: {clusterName}</h1>

            <div className={S.search}>
                <Input
                    disabled={!cluster}
                    className={S.search__input}
                    value={searchStoreName}
                    onChange={changeSearchStoreName}
                    placeholder="Search by name of store"
                />

                <Button className={S.search__button} color="brown" onClick={toClusterDashboard} disabled={!cluster}>
                    <Icon name="monitoring-ico" size={24} />
                    Cluster dashboard
                </Button>
            </div>
        </div>
    );
};
